<template>
  <!-- 用户管理-专属客服-添加或编辑 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type === 1 ? '添加客服' : '编辑客服'"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="image" label="客服类型">
          <el-select v-model="dataForm.type" placeholder="请选择类型">
            <el-option label="默认客服" :value="1"></el-option>
            <el-option label="其他客服" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="image" label="图片">
          <ImgUpload v-model="dataForm.image"></ImgUpload>
        </el-form-item>
        <el-form-item prop="name" label="客服名称">
          <el-input placeholder="请输入名称" v-model="dataForm.name">
          </el-input>
        </el-form-item>
        <el-form-item prop="recharge_amount" label="充值金额">
          <el-input placeholder="请输入金额" v-model="dataForm.recharge_amount">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import ImgUpload from '@/components/common/ImgUpload.vue'


export default {
  components: {
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dataForm: {
        type: 0,//客服类型 1默认 0其他
        image: '',
        name: '',//客服名称
        recharge_amount: 0
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      } else {
        this.dataForm = {
          type: 0,
          image: '',
          name: '',//客服名称
          recharge_amount: 0
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit(id) {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if (this.type === 1) {
        postApiData('customer_service', params).then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`customer_service/${this.dataForm.id}`, params).then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>